import { render, staticRenderFns } from "./SupplierReferenceDialog.vue?vue&type=template&id=3337edbb&scoped=true"
import script from "./SupplierReferenceDialog.vue?vue&type=script&lang=js"
export * from "./SupplierReferenceDialog.vue?vue&type=script&lang=js"
import style0 from "./SupplierReferenceDialog.vue?vue&type=style&index=0&id=3337edbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3337edbb",
  null
  
)

export default component.exports